module.exports = __webpack_public_path__ + "img/icon_yjhj.227a82f5.png";